import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { $calendar } from '../../Calendar.store';
import styles from './TableHeader.module.scss';
const TableHeader = ({ isLoading, className }) => {
    const { t } = useTranslation();
    const today = moment.tz($calendar.timezone).startOf('day');
    const onChangeSelectedDay = (canChange, date) => {
        if (canChange) {
            $calendar.SET_SELECTED_DAY(date);
        }
    };
    return (_jsx("div", Object.assign({ className: classNames(styles.tableHeader, $calendar.isDay && styles.isDay, $calendar.isMobile && styles.isMobile, className) }, { children: _jsx("div", Object.assign({ className: "container" }, { children: _jsx("div", Object.assign({ className: styles.content }, { children: $calendar.scheduleDays.map((date, index) => {
                    const scheduleDay = $calendar.schedule[date];
                    const isWorking = Boolean((scheduleDay === null || scheduleDay === void 0 ? void 0 : scheduleDay.workingTime.begin) && (scheduleDay === null || scheduleDay === void 0 ? void 0 : scheduleDay.workingTime.end));
                    const isToday = moment(date).isSame(today, 'day');
                    const isPast = moment(date).isBefore(today, 'day');
                    const isActive = moment(date).isSame($calendar.selectedDay, 'day');
                    const isDisabled = !isLoading ? (!isToday && !isActive && !isWorking) || isPast : true;
                    const title = $calendar.isDay
                        ? isToday
                            ? `${t('label.today')}, ${moment(date).format('MMMM D')} ${moment(date).format('YYYY')}`
                            : `${moment(date).format('MMMM D')} ${moment(date).format('YYYY')}`
                        : isToday
                            ? `${t('label.today')} ${moment(date).format('D')}`
                            : moment(date).format('ddd D');
                    const appointmentsCount = scheduleDay === null || scheduleDay === void 0 ? void 0 : scheduleDay.allAppointmentIds.size;
                    const subtitle = !isLoading
                        ? appointmentsCount > 0
                            ? t('label.appointments', { count: appointmentsCount })
                            : t(isWorking ? 'label.working' : 'label.non_working')
                        : `\u00A0`;
                    return (_jsxs("div", Object.assign({ className: classNames(styles.cell, isActive && $calendar.isWeek && styles.active, !isActive && isDisabled && styles.disabled), onClick: () => onChangeSelectedDay(!isDisabled, date) }, { children: [_jsx("div", Object.assign({ className: styles.title }, { children: title })), _jsx("div", Object.assign({ className: styles.subtitle }, { children: subtitle }))] }), [index, date].join('_')));
                }) })) })) })));
};
export default observer(TableHeader);
